import PRODUCT_TYPES from '../definitions/ProductTypes';


function isARewardsCard(cardType) {
    return [
        PRODUCT_TYPES.TRAVEL,
        PRODUCT_TYPES.CASH_BACK,
        PRODUCT_TYPES.STORE_CREDIT,
    ].includes(cardType);
}

export default isARewardsCard;
